export default "__VITE_ASSET__Bmz_YLwE__"